import { Injectable, inject } from '@angular/core';
import { HttpBaseService } from '../base_services/http_base.service';
import { LocalRepository } from '@shared/helper/local-repository';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServiceResult } from '@shared/helper/service-result';

@Injectable({
  providedIn: 'root'
})
export class BookmarkService extends HttpBaseService {

  constructor() {
    const repo = inject(LocalRepository);
    const http = inject(HttpClient);

    super(repo, http, 'bkm');
  }

  unMark(objectId: string): Observable<ServiceResult> {
    return this.http.delete<ServiceResult>(`${this.apiUrl}/unmark/${objectId}`);
  }
}
